import script from "./ResetPassForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassForm.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassForm.vue?vue&type=style&index=0&id=23b4e5c0&lang=css"

const __exports__ = script;

export default __exports__